export const getDollars = (amount = NaN) => {
  return amount.toFixed(2);
};

export const getCents = (amount = NaN) => {
  return +amount.toFixed(2).toString().split('.')[1];
};

export const getSampleAttributeValues = ({ specificationGroup, attributes }) => {
  const attributeValues = [];
  // match the sample attribute value with the attribute value from the parent
  attributes.forEach((attr) => {
    specificationGroup.forEach((specGroup) => {
      const { specifications } = specGroup;
      if (specifications.some(({ specName }) => specName === attr.attributeName)) {
        attributeValues.push(specifications.find(({ specName }) => specName === attr.attributeName).specValue);
      }
    });
  });

  let name = attributeValues.length ? attributeValues.reduce((acc, curr) => `${acc}, ${curr}`) : null;
  // fallback to Color Family if there is no proper combination name
  if (!name) {
    const details = specificationGroup?.find((spec) => spec.specTitle === 'Details');
    name = details?.specifications?.find((spec) => spec.specName === 'Color Family')?.specValue || null;
  }
  return name;
};

const getMetadataSampleColorSpecName = (attributes) => attributes?.find((attr) => attr.isSwatch)?.attributeName;

export const getSampleColorSpecValue = (attributes, sample) => {
  const details = sample.specificationGroup?.find((group) => group.specTitle === 'Details');
  const metadataSpecName = getMetadataSampleColorSpecName(attributes);
  return details?.specifications?.find((spec) => spec.specName === metadataSpecName)?.specValue || '';
};

export const getMetadataAttributeValues = (attributes) => {
  const metadataSpecName = getMetadataSampleColorSpecName(attributes);
  return attributes.find((attr) => attr.attributeName === metadataSpecName)
    ?.attributeValues?.map((attrValue) => attrValue.value) || [];
};

export const normalizeImageUrl = (url, size) => {
  const urlRE = /<SIZE>/i;
  return url.replace(urlRE, size);
};

const getMatchingChildItemId = ({ childItems, specificSkuName, excludedItemIds }) => {
  return childItems
    .find((childItem) => {
      return !!childItem.itemId
        && !excludedItemIds.includes(childItem.itemId)
        && childItem.attributeCombination.split('~~').includes(specificSkuName);
    })?.itemId;
};
const getFilteredChildItemIds = ({ childItems, specificSkuNames, excludedItemIds }) => {
  return childItems
    .filter((childItem) => {
      if (!!childItem.itemId && !excludedItemIds.includes(childItem.itemId)) {
        return specificSkuNames.filter((specificSkuName) => {
          return childItem.attributeCombination.split('~~').includes(specificSkuName);
        }).length;
      }
      return false;
    })
    .map((childItem) => childItem.itemId);
};

export const getAnchorItemIds = ({ metadata, specificSkuNames = [], excludedItemIds = [] }) => {
  if (metadata) {
    const childItems = metadata.childItemsLookup || [];
    const attributes = metadata.attributes || [];
    const skuNames = getMetadataAttributeValues(attributes)
      .filter((value) => !specificSkuNames.length || specificSkuNames.includes(value));
      
    if (childItems.length) {
      if (skuNames.length) {
        const tempItemIds = [];
        skuNames.forEach((skuName) => {
          // eslint-disable-next-line max-len
          const childItemsWithSkuName = getMatchingChildItemId({ childItems, specificSkuName: skuName, excludedItemIds });
          if (childItemsWithSkuName) {
            tempItemIds.push(childItemsWithSkuName);
          } else {
            // eslint-disable-next-line no-console
            console.warn(`could not find child item with SKU name ${skuName}`);
          }
        });
        return tempItemIds;
      }
      return getFilteredChildItemIds({ childItems, specificSkuNames, excludedItemIds });
    }
  }
  return [];
};